import { Avatar, Box, Flex, Typography } from "../../../ppui";
import { formatIndianCurrency } from "../../../utils/common";

export const SalaryHeaders = (currentPage, rowsPerPage) => [
  {
    key: "slNo",
    label: "SL No.",
    isShortable: true,
    isVisible: true,
    getValue: (row, index) => currentPage * rowsPerPage + index + 1,
  },
  {
    key: "employee_name",
    label: "Employee Name",
    align: "left",
    isClickable: true,
    isShortable: false,
    isVisible: true,
    isColumnSticky: "true",
    getValue: (rows) => (
      <>
        <Flex alignItems="center">
          <Avatar
            className={"avatarHover"}
            size="sm"
            color="secondary"
            initials={`${rows.employee_name.trim().substring(0, 1).toUpperCase()}`} // Join the initials with a dot
            sx={{ marginInlineEnd: "0.625rem" }}
          />
          <Box>
            {rows.employee_name}
            <Typography
              color={"default"}
              colorVariant={"light"}
              variant={"body2"}
              mb={"0"}
            >
              #{rows.employee_code}
            </Typography>
          </Box>
        </Flex>
      </>
    ),
  },
  {
    key: "age",
    label: "Age As Per This Month",
    align: "center",
    isShortable: false,
    isVisible: true,
    getValue: (row) => row?.employees?.age ? row?.employees?.age : '--',
  },
  {
    key: "epf_no",
    label: "EPF No.",
    align: "left",
    isShortable: false,
    isVisible: true,
    // isColumnSticky: "true",
    getValue: (row) => row?.employees?.epf_no ? row?.employees?.epf_no : '--',
  },
  {
    key: "uan_no",
    label: "UAN",
    isShortable: false,
    isVisible: true,
    getValue: (row) => row?.employees?.uan_no ? row?.employees?.uan_no : '--',
  },
  {
    key: "",
    label: "PAYABLE DAYS",
    align: "center",
    isShortable: false,
    isVisible: true,
    getValue: (row) => row?.payable_days ? row?.payable_days : '0',
  },
  {
    key: "",
    label: "NCP DAYS",
    align: "center",
    isShortable: false,
    isVisible: true,
    getValue: (row) => row?.ncp_days ? row?.ncp_days : '0',
  },
  {
    key: "gross_salary",
    label: "Gross Pay",
    align: "right",
    isShortable: false,
    isVisible: true,
    getValue: (row) => row?.gross_salary ? `${formatIndianCurrency(Math.round(Number(row?.gross_salary)))}` : '--',
  },
  {
    key: "epf_wages",
    label: "EPF Wages",
    align: "right",
    isShortable: false,
    isVisible: true,
    getValue: (row) => row?.epf_wages ? `${formatIndianCurrency(Math.round(Number(row?.epf_wages)))}` : '--',
  },
  {
    key: "epf_wages",
    label: "EPS Wages",
    align: "right",
    isShortable: false,
    isVisible: true,
    getValue: (row) => row?.epf_wages
      ? row?.employees?.age <= 58
        ? `${formatIndianCurrency(Math.round(Number(row?.epf_wages)))}`
        : "NA"
      : '00',
  },
  {
    key: "epf_wages",
    label: "EDLI Wages",
    align: "right",
    isShortable: false,
    isVisible: true,
    getValue: (row) => row?.epf_wages ? `${formatIndianCurrency(Math.round(Number(row?.epf_wages)))}` : '00',
  },
  {
    key: "contri",
    label: "Employee Contribution",
    align: "right",
    isShortable: false,
    isVisible: true,
    getValue: (row) => row?.epf_amount ? `${formatIndianCurrency(Math.round(Number(row?.epf_amount)))}` : '00',
  },
  {
    key: "eps",
    label: "Employer Contribution (EPS)",
    align: "right",
    isShortable: false,
    isVisible: true,
    getValue: (row) => {
      const employerEPSPercentage = Number((row?.epf_wages * 8.33) / 100).toFixed(2);
      const employerEPSAmount = employerEPSPercentage <= 1250 ? employerEPSPercentage : 1250;
      return row?.employees?.age <= 58 ? `${formatIndianCurrency(Math.ceil(Number(employerEPSAmount)))}` : "NA";
    },
  },
  {
    key: "EPF",
    label: "Employer Contribution (EPF)",
    align: "right",
    isShortable: false,
    isVisible: true,
    getValue: (row) => {
      const employerEPSPercentage = Number((row?.epf_wages * 8.33) / 100).toFixed(2);
      const employerEPSAmount = row?.employees?.age <= 58
        ? employerEPSPercentage <= 1250
          ? employerEPSPercentage
          : 1250
        : 0;
      const employerEPFAmount = Math.floor(Number(row?.ee_epf_amount - employerEPSAmount))
      // return `${formatIndianCurrency(employerEPFAmount)}`;
      return formatIndianCurrency(employerEPFAmount)
    },
  },
  // {
  //   key: "epf_arrear",
  //   label: "EPF Arear",
  //   align: "right",
  //   isShortable: false,
  //   isVisible: true,
  //   getValue: (row) => row?.epf_arrear? row?.epf_arrear : '00',
  // },
  {
    key: "remarks",
    label: "Remarks",
    align: "left",
    isShortable: false,
    isVisible: true,
    getValue: (row) => {
      const joinDate = row?.employees?.join_date ? new Date(row.employees.join_date) : null;
      const exitDate = row?.employees?.exit_formalities?.[0]?.exit_date ? new Date(row?.employees?.exit_formalities?.[0]?.exit_date) : null;
      const recordMonth = row?.month;
      const recordYear = row?.year;
      if (joinDate && joinDate.getMonth() + 1 === recordMonth && joinDate.getFullYear() === recordYear) {
        return `The Employee joined on ${joinDate.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}`;
      }
      if (exitDate && exitDate.getMonth() + 1 === recordMonth && exitDate.getFullYear() === recordYear) {
        return `Employee exited at ${exitDate.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}`;
      }
      return row?.remarks || "--";
    }
  },
];

export const SalaryRows = [
  {
    slNo: 1,
    employeeName: "Barun Sharma",
    uan: "1234567890",
    epfWages: "1500",
    eeContribution: "2000",
    remarks: "-",
    age: "26",
  },
];

